import { fromCircle, fromExtent } from 'ol/geom/Polygon';
import { Circle, MultiPolygon, Polygon, type SimpleGeometry } from 'ol/geom';

import { Rectangle } from 'cadenza/map/geom/rectangle';

/**
 * Default number of points in the polygon that approximates a circle.
 *
 * @type {number}
 */
export const DEFAULT_SIDES_IN_CIRCLE_POLYGON = 128;

export function circleToPolygon (geometry: Circle, numberOfPoints = DEFAULT_SIDES_IN_CIRCLE_POLYGON) {
  return fromCircle(geometry, numberOfPoints);
}

export function convertRectangleOrCircleGeometryIfNeeded (geometry: SimpleGeometry, isMultiGeometry = false): SimpleGeometry {
  // Do not directly return the geometry here, since it may get modified (appended new geometries for example)
  if (geometry instanceof Polygon || geometry instanceof MultiPolygon || geometry instanceof Circle || geometry instanceof Rectangle) {
    const standardGeometry = convertRectangleOrCircleToPolygonOrMultiPolygon(geometry, isMultiGeometry);
    // No need to clone if Circle or Rectangle, since it's a new geometry anyway
    return geometry instanceof Circle || geometry instanceof Rectangle ? standardGeometry : standardGeometry.clone();
  }
  return geometry.clone() as SimpleGeometry;
}

export function convertRectangleOrCircleToPolygonOrMultiPolygon (geometry: Polygon | MultiPolygon | Circle | Rectangle, isMultiGeometry = false) {
  if (geometry instanceof Circle) {
    const polygon = circleToPolygon(geometry);
    return isMultiGeometry ? new MultiPolygon([ polygon.getCoordinates() ]) : polygon;
  } else if (geometry instanceof Rectangle) {
    return isMultiGeometry ? new MultiPolygon([ geometry.getCoordinates() ]) : fromExtent(geometry.getExtent());
  }
  return geometry;
}
